import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { endReplay } from "../../src/shell/endReplay";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { jenny } from "../characters/Jenny";
import { mc } from "../characters/MC";
import { empty } from "../characters/empty";
import { doSmsSound, doTransition, doWaitImageByTime, isMcLikesNTR, random, randomFloat } from "../helpers/helpers";
import { V8AnnChrisTextingAfter } from "./V8";
import { extras, images } from "./images";


async function history(part: number) {

    await Phone.showMessagesUI({ name: ann.name }, async () => {
        Phone.setMessage({ character: ann.character, text: `I wish you were here! 😘`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Not enjoying the movie?`, options: { wait: part == 1 } });
        Phone.setMessage({ character: ann.character, text: `Hehe! About to start right now.`, options: { wait: part == 1 } });
        Phone.setMessage({ character: ann.character, text: `I'll keep you posted if it's good or not! 😊`, options: { wait: part == 1 } });
        Phone.setMessage({ character: mc.character, text: `Enjoy! :)`, options: { wait: part == 1 } });



        if (part > 1) {
            // TODO: wine time
            Phone.setMessage({ character: ann.character, text: `Wineee timeee`, options: { wait: false } });
            Phone.setImage({ ...images.v8.V8AnnChrisPics_9, character: ann.character, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `I see you are having fun.`, options: { wait: part == 2 } });
            Phone.setMessage({ character: ann.character, text: `Not as much as I would if you were here!`, options: { wait: part == 2 } });
            Phone.setMessage({ character: mc.character, text: `:)`, options: { wait: part == 2 } });
            Phone.setMessage({ character: ann.character, text: `😘`, options: { wait: part == 2 } });
            Phone.setMessage({ character: ann.character, text: `Chris joined me finally!`, options: { wait: part == 2 } });
            Phone.setImage({ ...images.v8.V8AnnChrisPics_8, character: ann.character, options: { wait: part == 2 } });
            Phone.setMessage({ character: ann.character, text: `Okie! The movie is starting! 😚`, options: { wait: part == 2 } });
        }

        if (part > 2) {

            Phone.setImage({ ...images.v8.V8AnnChrisPics_0, character: ann.character, options: { wait: false } });

            if (part == 3) {
                Phone.talk({ character: mc.character, text: `Chris is taking kinky photos of Ann...`, options: { think: true, wait: part == 3 } });
                Phone.talk({ character: mc.character, text: `She definitely feels comfortable around him.`, options: { think: true, wait: part == 3 } });
                Phone.talk({ character: mc.character, text: ``, options: { wait: false, think: true } });
            }
            if (part == 3) {
                await Phone.setQuestion({
                    character: mc.character, question: new Question({ text: `HOT`, options: { think: false }, key: `v8AnnChrisTextingSaidSheIsHot` })
                        .option({ title: `HOT! 🔥`, key: true })
                        .option({ title: `:)`, key: false })
                });
            }
            if (Question.globalAnswers.v8AnnChrisTextingSaidSheIsHot) {
                Phone.setMessage({ character: mc.character, text: `HOT! 🔥`, options: { think: false, wait: part == 3 } });
                Phone.setMessage({ character: ann.character, text: `HOLD ON!`, options: { think: false, wait: part == 3 ? randomFloat(1, 2) : false } });

                if (part == 3) {
                    Phone.talk({ character: mc.character, text: `I wonder what she is planning....`, options: { think: false, wait: true, style: { overlay: true } } });
                    Phone.talk({ character: mc.character, text: ``, options: { wait: false, think: false } });
                }

                Phone.setImage({ ...images.v8.V8AnnChrisPics_1, character: ann.character, options: { wait: part == 3 } });
                Phone.setMessage({ character: mc.character, text: `WOW!`, options: { wait: part == 3 ? randomFloat(1, 2) : false } });
                Phone.setMessage({ character: mc.character, text: `I'm dying!`, options: { wait: part == 3 } });

                Phone.setMessage({ character: ann.character, text: `Alright! Chris is begging for some attention! 😘`, options: { wait: part == 3 } });
                Phone.setImage({ ...images.v8.V8AnnChrisPics_10, character: ann.character, options: { wait: part == 3 } });
                Phone.setMessage({ character: ann.character, text: `Time to watch the movie 😜`, options: { wait: part == 3 } });

            } else {
                Phone.setMessage({ character: mc.character, text: `:)`, options: { wait: part == 3 } });
                Phone.setMessage({ character: ann.character, text: `You don't like? :(`, options: { wait: part == 3 } });
                Phone.setMessage({ character: mc.character, text: `Talk to me after the movie :)`, options: { wait: part == 3 } });
            }
        }
        if (part > 3 && Question.globalAnswers.v8AnnChrisTextingAskMorePhotos) {
            Phone.setMessage({ character: mc.character, text: `So? Enjoying the movie?`, options: { wait: part == 4 } });
            Phone.setMessage({ character: ann.character, text: `I am! 😁`, options: { wait: part == 4 } });
            Phone.setMessage({ character: mc.character, text: `Explain?`, options: { wait: part == 4 } });
            Phone.setMessage({ character: ann.character, text: `Ok! Hold on!`, options: { wait: part == 4 } });
            // going down on Ann
            Phone.setImage({ ...images.v8.V8AnnChrisPics_11, character: ann.character, options: { wait: part == 4 } });
            Phone.setMessage({ character: ann.character, text: `Chris is busy 😁`, options: { wait: part == 4 } });
            Phone.setMessage({ character: mc.character, text: `I can see that.`, options: { wait: part == 4 } });
            Phone.setMessage({ character: ann.character, text: `Miss you! 👄`, options: { wait: part == 4 } });
            // frame 12
            Phone.setImage({ ...images.v8.V8AnnChrisPics_12, character: ann.character, options: { wait: part == 4 } });
            Phone.setMessage({ character: ann.character, text: `i told chris bout out photoshoot today and he alsoo awanted to take some picctures`, options: { wait: part == 4 } });
            Phone.setMessage({ character: ann.character, text: `sry! its hard to write with one hand 😊`, options: { wait: part == 4 } });
            if (part == 4) {
                Phone.talk({ character: mc.character, text: `Ann is texting me while having Chris's cock in her mouth...`, options: { think: true, wait: true } });
                Phone.talk({ character: mc.character, text: `I knew they are fooling around but now I'm actually seeing it...`, options: { think: true, wait: true } });
                Phone.talk({ character: mc.character, text: `And for some reason it kinda turns me on...`, options: { think: true, wait: true } });
                Phone.talk({ character: mc.character, text: ``, options: { think: true, wait: part == 4 } });
            }
            // 13
            Phone.setImage({ ...images.v8.V8AnnChrisPics_13, character: ann.character, options: { wait: part == 4 } });
            // 14
            Phone.setImage({ ...images.v8.V8AnnChrisPics_14, character: ann.character, options: { wait: part == 4 } });
            // 15
            Phone.setImage({ ...images.v8.V8AnnChrisPics_15, character: ann.character, options: { wait: part == 4 } });
            if (part == 4) {
                Phone.talk({ character: mc.character, text: `Chris took over the phone...`, options: { think: true, wait: true } });
                Phone.talk({ character: mc.character, text: `He seems to enjoy this... Just look at this smug.`, options: { think: true, wait: true } });
                Phone.talk({ character: mc.character, text: ``, options: { think: true, wait: part == 4 } });
            }
            // 16
            Phone.setImage({ ...images.v8.V8AnnChrisPics_16, character: ann.character, options: { wait: part == 4 } });
            Phone.setMessage({ character: ann.character, text: `I'm back!`, options: { wait: part == 4 } });
            Phone.setMessage({ character: mc.character, text: `You seemed busy.`, options: { wait: part == 4 } });
            Phone.setMessage({ character: ann.character, text: `I did it for you! :)`, options: { wait: part == 4 } });
            if (part == 4) {

                await Phone.setQuestion({
                    character: mc.character, question: new Question({ text: `Did it for you`, options: { think: false }, key: `v8AnnChrisTextingSaidHeLovedIt` })
                        .option({ title: `I love it`, key: true })
                        .option({ title: `I wish that was me`, key: false })
                });
            }
            if (Question.globalAnswers.v8AnnChrisTextingSaidHeLovedIt) {
                Phone.setMessage({ character: mc.character, text: `I love it!`, options: { wait: part == 4 } });
                Phone.setMessage({ character: ann.character, text: `😍`, options: { wait: part == 4 } });
            } else {
                Phone.setMessage({ character: mc.character, text: `I wish that was me`, options: { wait: part == 4 } });
                Phone.setMessage({ character: ann.character, text: `It will be you ❣️`, options: { wait: part == 4 } });
            }

            Phone.setMessage({ character: mc.character, text: `Are you done yet?`, options: { wait: part == 4 } });
            // 17
            Phone.setMessage({ character: ann.character, text: `Not really!`, options: { wait: part == 4 ? randomFloat(0.2, 1) : false } });
            Phone.setImage({ ...images.v8.V8AnnChrisPics_17, character: ann.character, options: { wait: part == 4 } });

            Phone.setMessage({ character: ann.character, text: `Talked too soon!`, options: { wait: part == 4 ? randomFloat(0.3, 1) : false } });
            Phone.setMessage({ character: ann.character, text: `Now we are done!`, options: { wait: part == 4 ? randomFloat(0.8, 1.2) : false } });
            // 18
            Phone.setImage({ ...images.v8.V8AnnChrisPics_18, character: ann.character, options: { wait: part == 4 ? randomFloat(0.3, 1) : false } });
            Phone.setMessage({ character: ann.character, text: `We made a mess!`, options: { wait: part == 4 ? randomFloat(0.5, 1) : false } });
            Phone.setMessage({ character: ann.character, text: `Look at this! 😳`, options: { wait: part == 4 ? randomFloat(0.8, 1.2) : false } });
            // 6
            Phone.setImage({ ...images.v8.V8AnnChrisPics_6, character: ann.character, options: { wait: part == 4 ? randomFloat(0.3, 1) : false } });
            Phone.setMessage({ character: ann.character, text: `lol! Chris doesn't want me to wipe it off!`, options: { wait: part == 4 ? randomFloat(0.8, 1.2) : false } });
            // 7
            if (Question.globalAnswers.v8AnnChrisTextingAskMorePhotos && part == 4) {

                ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_0.partials.V8MCRoomBeforeSleep_0_p, { wait: false, putParent: true });
            }
            Phone.setImage({ ...images.v8.V8AnnChrisPics_7, character: ann.character, options: { wait: part == 4 } });

            Phone.setMessage({ character: ann.character, text: `Alright we're gonna really watch the movie now 😚😚😚`, options: { wait: part == 4 } });

        }
        if (part > 4 && !Question.globalAnswers.v8AnnChrisTextingAskMorePhotos) {
            Phone.setMessage({ character: ann.character, text: `I really really really wish your were here 😘`, options: { wait: false } });
            Phone.setImage({ ...images.v8.V8AnnChrisPics_6, character: ann.character, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `Is that what I think it is?`, options: { wait: part == 5 } });
            Phone.setMessage({ character: ann.character, text: `😇`, options: { wait: part == 5 } });
        }

        if (part > 5) {
            Phone.setMessage({
                character: ann.character, text: `So I told Chris about today...\nAnd he knows a lot about anal plugs 😅\nI guess I'm more naive then I thought!\nAnyway he offered to help!`
                , options: { wait: false }
            });
            Phone.setMessage({ character: mc.character, text: `What does that means?`, options: { wait: part == 6 ? 1 : false } });
            Phone.setMessage({ character: ann.character, text: `Sec.`, options: { wait: part == 6 ? randomFloat(1, 1.5) : false } });

            if (!Question.globalAnswers.v8AnnChrisTextingAskMorePhotos && part == 6) {
                // ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_0, { wait: false });
            }
            Phone.setImage({ ...images.v8.V8AnnChrisPics_19, character: ann.character, options: { wait: part == 6 ? randomFloat(0.2, 0.9) : false } });
            Phone.setMessage({ character: ann.character, text: `😳`, options: { wait: part == 6 ? randomFloat(1, 2) : false } });
            Phone.setMessage({
                character: ann.character, text: `Not fully in! But it's something!\nTalk to you tomorrow! Good night 😘`
                , options: { wait: part == 6 }
            });

        }

        Phone.closeMessagesUI();
    });

}

export const V8AnnChrisTexting = async (): Promise<any> => {
    doSmsSound();
    mc.think(`It's Ann.`);
    mc.think(`Why is she texting me? Isn't she supposed to be watching a movie with Chris right now?`);
    await history(1);
    mc.think(`It's weird that she is texting me while at Chris's.`);
    mc.think(`He seems to be okay with that...`);

    doTransition(images.v5.Room2_2);
    doSmsSound();
    mc.think(`Ann, again? Is she bored or something?`);
    await history(2);

    mc.think(`Since I decided to stay home I'll at least try to make the most of my time.`);
    doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_4);
    mc.think(`And by most of my time I mean let out a quick one before going to sleep...`);
    ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5);

    doSmsSound();
    ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
    mc.think(`Come on...`);
    ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5);
    mc.think(`An attachment from Ann again.`);
    await history(3);

    if (Question.globalAnswers.v8AnnChrisTextingSaidSheIsHot) {
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
        mc.think(`Chris took those nude photos of her...`);
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5);
        mc.think(`No wonder he wants attention. I bet he got turned on as much as I did.`);
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
        mc.think(`And he is in the same room with her...`);
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5);
        mc.think(`It's so obvious what they are doing right now.`);
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
        await mc.setQuestion(new Question({ text: `But some part of me wants to know...`, options: { think: true }, key: `v8AnnChrisTextingAskMorePhotos` })
            .option({ title: `Ask for more photos`, key: true })
            .option({ title: `Go to sleep`, key: false }));


        if (Question.globalAnswers.v8AnnChrisTextingAskMorePhotos) {
            return jump(V8AnnChrisTexting_AskForMorePhotos, "V8AnnChrisTexting_AskForMorePhotos");


        } else {
            ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5);
            mc.think(`Nah! Fuck it.`);
            ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
            mc.think(`It's better to keep it only as a part of my imagination.`);

        }

    } else {

        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
        mc.think(`I hope I didn't come across as jealous...`);
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5);
        mc.think(`I allowed her to hang out with Chris alone, but I can do without the pictures.`);
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
        mc.think(`Besides, I'm trying to focus here!`);

    }




    return jump(V8AnnChrisTexting_2, "V8AnnChrisTexting_2");
};

export const V8AnnChrisTexting_AskForMorePhotos = async (): Promise<any> => {
    await history(4);
    mc.think(`Damn that's so fucking hot!`);
    ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_9);
    mc.think(`I can't hold it!`);
    doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_2, { wait: true });
    ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_8);
    mc.think(`Ahh!!!`);
    doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_14.partials.V8MCRoomBeforeSleep_14_p, { putParent: true });
    mc.think(`Fuck... That was good.`);
    mc.think(`I can't believe I came to pictures of Ann and Chris fucking.`);
    doWaitImageByTime(images.v5.Room2_2);
    mc.think(`That was something...`);
    mc.think(`I'm not naive, it was obvious they aren't playing chess...`);
    mc.think(`But getting those texts was something new.`);
    return jump(V8AnnChrisTexting_2, "V8AnnChrisTexting_2");
};
export const V8AnnChrisTexting_DontAskForMorePhotos = async (): Promise<any> => {
    //ImageClass.setImage(images.TODO_IMAGE)
    mc.think(`I could've joined them but I decided to stay home...`);
    mc.think(`I'll just let them enjoy their time together.`);
    return jump(V8AnnChrisTexting_2, "V8AnnChrisTexting_2");
};

export const V8AnnChrisTexting_2 = async (): Promise<any> => {
    if (Question.globalAnswers.v8AnnChrisTextingAskMorePhotos) {


    } else {
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5);
        mc.think(`Any minute now...`);
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4, { wait: 0.5 });
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5, { wait: 0.5 });
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4, { wait: 0.5 });
        ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5, { wait: 0.5 });
        if (Question.globalAnswers.V1NtrUnexpected) {
            // Sleeping in bed.

            doSmsSound();
            await history(5);

            mc.think(`The fuck?`);
            mc.think(`I told her I don't want anymore photos and she is sending me a picture of herself covered with Chris's cum?`);
            ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
            mc.think(`What was she thinking...`);
            ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_5);
            mc.think(`At least it's over now and I can cum in peace.`);

        } else {
            doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_12, { wait: 0.5 });
            doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_11, { wait: true });
            doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_2, { wait: true });
            doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_6);
            mc.think(`Ah...`);
            mc.think(`Now I can sleep...`);

        }

    }
    if (Question.globalAnswers.V1NtrUnexpected) {
        if (!Question.globalAnswers.v8AnnChrisTextingAskMorePhotos) {
            ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_4);
            mc.think(`Fuck, I'm cumming!`);
        }

        doSmsSound();
        await history(6);
        if (!Question.globalAnswers.v8AnnChrisTextingAskMorePhotos) {
            mc.think(`What the...`);
            ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_0);
            mc.think(`Fuck, I can't control it!`);
            ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_1, { wait: true });
            doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_2, { wait: true });
            ImageClass.setImage(images.v8.V8MCRoomBeforeSleep_7);
            mc.think(`Ahh!!!`);
            doWaitImageByTime(images.v8.V8MCRoomBeforeSleep_14);
            mc.think(`Fuck! I just came to Chris fucking my girlfriend in the ass...`);
            mc.think(`Or at least trying to...`);
        }

        if (Question.globalAnswers.v8AnnCorAfterLibraryFuckHerAss) {
            mc.think(`I did it first so the joke is on him!`);
            if (isMcLikesNTR()) {
                mc.think(`But I can't deny it... It was hot seeing these pictures...`);
            }

        } else {
            if (isMcLikesNTR()) {
                mc.think(`I can't deny... That was hot...`);

            } else {

                mc.think(`I didn't stick my dick inside her ass because I didn't want to push too hard and she does it with Chris?`);
                mc.think(`I can't believe he took her ass virginity...`);
                mc.think(`But can I really blame anyone besides myself...?`);
                mc.think(`I'm the one who allowed her to see him in the first place, and I'm the one who kept allowing her to meet with him...`);
            }

        }

    }
    if (Question.globalAnswers.v8AnnChrisTextingAskMorePhotos) {

        await endReplay(replayScenesList.v8AnnChrisSexting);
    }

    await endReplay();

    return jump(V8AnnChrisTextingAfter, "V8AnnChrisTextingAfter");
};